import { v4 } from 'uuid';

import IMAGES from './images';
import Particle from './particle';
import type { ConfettiOptionsType } from '..';

const particles = new Map();

function repaint(canvas: HTMLCanvasElement): void {
  const canvasContext = canvas.getContext('2d');

  if (canvasContext) {
    canvasContext.clearRect(0, 0, canvas.width, canvas.height);
  }

  particles.forEach((particle, key) => {
    const updateValue = particle.update();

    if (!updateValue) {
      particles.delete(key);
    }
  });

  window.requestAnimationFrame(() => repaint(canvas));
}

const randomNumberInRange = (min: number, max: number): number =>
  Math.random() * (max - min) + min;

const explodeConfetti = (
  canvas: HTMLCanvasElement,
  options: ConfettiOptionsType,
): void => {
  if (!canvas) return;

  const fullOptions = {
    isInfinite: false,
    numParticles: 20,
    imgArray: IMAGES,
    speedRange: [1, 3],
    ...options,
  };

  const { isInfinite, numParticles, imgArray, speedRange } = fullOptions;

  for (let index = 0; index < numParticles; index += 1) {
    // grab random svg path
    const svgPath = imgArray[Math.floor(Math.random() * imgArray.length)];
    const randomXPosition = randomNumberInRange(0, canvas.width);
    const randomYPosition = randomNumberInRange(-10, 10);
    const randomSpeed = randomNumberInRange(speedRange[0], speedRange[1]);
    const randomRotate = randomNumberInRange(100, 200);

    const newParticle = new Particle(
      randomSpeed,
      randomXPosition,
      randomYPosition,
      randomRotate,
      svgPath,
      canvas,
      isInfinite,
    );

    particles.set(v4(), newParticle);
  }

  repaint(canvas);
};

export default explodeConfetti;
